var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.get_options.bg)?_c('div',{staticClass:"bpb-background",style:(_vm.get_zindex)}):_vm._e(),_c('div',{class:_vm.get_class,style:(_vm.get_width+';'+_vm.get_height+';'+_vm.get_zindex)},[_vm._t("default"),(_vm.get_options.close)?_c('div',{staticClass:"close icon-cross",on:{"click":_vm.close}}):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }